import React from 'react'

function TermsOfServiceComponent() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
      <h1>Terms of Service</h1>
      <p>
        <strong>Effective February 27, 2017</strong>
      </p>
      <p>
        Welcome to Legends of Learning! These are the terms of your using our in
        school online game based learning and content platform (the
        &quot;Platform&quot;), and any other websites, applications, Application
        Programming Interfaces (&quot;APIs&quot;), and online services provided
        in connection with the Platform (collectively, with the Platform, the
        &quot;Services&quot;) and are operated by Legends of Learning, Inc.
        (&quot;Legends of Learning&quot;, &quot;we&quot;, &quot;our,&quot; or
        &quot;us&quot;).
      </p>
      <p>
        By using the Services, you agree to the following Terms and Conditions
        (&quot;Terms&quot;).
      </p>
      <p>
        <strong>PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY.</strong>
      </p>
      <p>
        If you use the Services, or if you register as a user, you are agreeing
        to these terms as well as to our Privacy Policy, which describes how we
        collect and use information about you. If your school, school district
        or other educational institution (each an &quot;Educational
        Institution&quot;) has a separate agreement with us, these terms will
        apply only to the extent they do not conflict with that agreement.
      </p>
      <p>
        Our Services are not offered directly to students. Educational
        Institutions or teachers must first sign up for primary accounts, and
        then invite students to use Legends of Learning through student
        accounts. If we learn that a student of any age has created a primary
        account, that account will be deleted. For more information on our
        treatment of information collected from children under the age of 13,
        please see the Legends of Learning Privacy Policy.
      </p>
      <h2>Changes to These Terms and Conditions and to the Services</h2>
      <p>
        We may amend these Terms from time to time. The most current version
        will always be here. If we believe an amendment is material, we will
        notify you by emailing the email address you provided to us, if you have
        provided one. By continuing to access or use the Services after an
        amendment becomes effective, you agree to be bound by the amended Terms.
        We may change the functionality of the Services, or stop offering the
        Services altogether, at any time and without notice to you.
      </p>
      <h2>Our Rights and Our License to You</h2>
      <p>
        The games, assessments, video, images, audio and text, question bank, or
        any other content available through the Services (&quot;Content&quot;)
        and all intellectual property pertaining to or contained on the Services
        (including but not limited to copyrights, patents, database rights,
        graphics, designs, text, logos, trade dress, trademarks, and service
        marks) are owned by us or third parties who have granted us the rights
        to use them. All rights, title, and interest in these remain the
        property of Legends of Learning and/or such third-party owner, as
        applicable. All content is protected by trade dress, copyright, patent,
        and trademark laws, as well as various other intellectual property and
        unfair competition laws.
      </p>
      <p>
        Some of our Content is licensed under Creative Commons licenses. This
        content will be labeled with the applicable type of license, e.g.
        &quot;CC BY-NC- SA.&quot; Certain Creative Commons Licenses prohibit use
        for commercial purposes and require certain attribution. Please read the
        terms of the relevant license carefully before using it. Any use or
        sharing of such content is subject to the terms of the relevant Creative
        Commons License. The licenses can be found here:{' '}
        <a
          href='https://creativecommons.org/licenses'
          target='_blank'
          rel='noopener noreferrer'
        >
          https://creativecommons.org/licenses
        </a>
      </p>
      <p>
        Subject to the terms of third party licenses, we grant you a
        royalty-free, non-exclusive, non-transferrable, worldwide license to
        view, download and use our Content, view and make copies of relevant
        documents, pages, images, or other materials on the Services and to
        transmit and perform such materials, provided that all such use is made
        in K-12 educational settings or for non-commercial purposes.
      </p>
      <p>
        You agree that you will not duplicate, publish, modify, create
        derivative works from, participate in the transfer of, post on the World
        Wide Web, or in any way distribute or exploit the Content or the
        Services, or any portion of the Content or Services, for any public or
        commercial use without our express written consent. Additionally, you
        agree that you (i) will not remove or alter any author, trademark, or
        other proprietary notice or legend displayed on the Services (or printed
        pages produced from the Services), and (ii) will not make any other
        modifications to any documents obtained from this other than in
        connection with completing information required for your use of the
        Services.
      </p>
      <h2>Eligibility and Registration</h2>
      <p>
        Our Services are not offered directly to students on any basis.
        Educational Institutions or teachers who are at least 18 years of age,
        must first sign up for primary accounts, and then invite students to use
        Legends of Learning through student accounts. If we learn that a student
        of any age has created a primary account, that account will be deleted.
        For children under 13, we require teacher or Educational Institution
        consent.
      </p>
      <p>
        By using the Service, you represent and warrant that (a) you are at
        least 18 years of age and a teach at an Educational Institution (b) all
        registration information you submit is truthful and accurate; (c) you
        will maintain the accuracy of such information; (d) you are acting and
        are authorized to act on behalf of parents to give Legends of Learning
        permission to collect the information described in the Privacy Policy
        with respect to your students who will be using the Services and that
        (e) your use of the Service does not violate any applicable law or
        regulation.
      </p>
      <p>
        You agree to provide true, accurate, current, and complete information
        about yourself and the users of the account as prompted by the Services
        registration form (such information, being the &quot;Registration
        Data&quot;), and you agree to maintain and promptly update the
        Registration Data to keep it true, accurate, current, and complete. If
        you provide any information that is untrue, inaccurate, not current, or
        incomplete, or we have any reasonable grounds to suspect that such
        information is untrue, inaccurate, not current, or incomplete, we may
        suspend or terminate your account and refuse to offer you any and all
        current or future use of the Services.
      </p>
      <p>
        You are responsible for maintaining the security of your account and
        data. Any account name, password, or user ID supplied to you in
        connection with the Services is personal to you and the members of your
        household, and you may not transfer or make available your account name,
        password, or user ID to others. We encourage you to use
        &quot;strong&quot; passwords (passwords that use a combination of upper
        and lower case letters, numbers and symbols) with your account.
      </p>
      <p>
        You are entirely responsible for any actions that are taken using your
        login information or credentials, even if they are obtained illegally by
        someone (such as a hacker) or if you disclose them by accident. You must
        notify us immediately of any unauthorized uses of your data, your
        account or any other breaches of security. You are fully responsible for
        all activities that occur under the account. If you share any of this
        information we reserve the right to cancel your registration. For Fee
        based services sharing this information may result in the cancellation
        of your account without a refund as well as in the imposition of
        additional charges based on your unauthorized use.
      </p>
      <p>
        We will not be liable for any acts or omissions by you, including any
        damages of any kind incurred as a result of such acts or omissions.
      </p>
      <h2>Fee Based Services, Credits</h2>
      <p>
        Some Services may be offered to you on a fee basis. All fees are quoted
        and must be paid in U.S Dollars. If you elect to purchase fee-based
        Services and transmit to Legends of Learning a purchase request, you
        warrant that your use of the particular credit card or other accepted
        payment method is authorized and that all information that you submit to
        Legends of Learning, or any third party designated by Legends of
        Learning, is true and accurate (including, without limitation, your
        credit card number and expiration date), and you agree to pay all fees,
        including any applicable sales taxes, you incur.
      </p>
      <p>
        You may also receive the ability to use some of the Services for free
        for a defined period of time or for a certain quantity of usage or
        otherwise subject to certain restrictions further described in the
        Platform. Upon the expiration of the time for free usage or otherwise
        upon the end of the free usage period, Legends of Learning may turn off
        or otherwise restrict use of any or all free portions of the Services.
        The terms of the offering of any portion of the Services for free may
        change from time to time without any notice.
      </p>
      <h2>User Submissions</h2>
      <p>
        We will treat any personally identifiable information you provide to us
        via the Services in accordance with our Privacy Policy.
      </p>
      <p>
        Any information which is submitted to public areas of the Services,
        including the online forum or any client testimonials, and any
        information not containing personally identifiable information, which
        you post on the Platform or submit through the Services including any
        reviews, feedback, questions, suggestions, suggested additions to our
        question bank or to other parts of our Content (&quot;Your
        Content&quot;) will be treated as described below.
      </p>
      <p>
        You represent and warrant that: (i) you own Your Content or that you
        otherwise have the right to grant us the licenses and rights to Your
        Content as are described below, (ii) that the posting, submission or use
        of Your Content does not violate the privacy rights, publicity rights,
        copyright, contract rights, intellectual property rights, creative
        commons license, or any other rights of any person, and (iii) the
        posting, submission or use of Your Content does not result in a breach
        of contract between you and a third party.
      </p>
      <p>
        You agree that you are entirely responsible for the composition of, and
        any costs or damages resulting from Your Content.
      </p>
      <p>
        You also grant us a worldwide, non-exclusive, royalty-free license (with
        the right to sublicense) to copy, reproduce, process, adapt, modify,
        publish, transmit, display, and distribute Your Content in any and all
        media or distribution methods (now known or later developed) and use
        Your Content in any way we may decide in our sole discretion and without
        any consideration to you.
      </p>
      <p>
        You waive any rights you may have regarding to our altering or
        manipulating Your Content in any way that may be objectionable to you.
        We reserve the right, in our sole discretion, to refuse to accept, post,
        display, or transmit any or all parts of Your Content.
      </p>
      <h2>
        Use of Legends of Learning&apos;s Teacher Community and Forum and
        Services
      </h2>
      <p>
        We expect users of our online forums to interact with each other as
        respectful educational professionals and to post only appropriate
        Content. The forums are only available for teachers, game developers,
        curriculum professionals and other individuals invited by Legends of
        Learning. Students may not participate in the forum. We may suspend or
        terminate the accounts of users for any reason, in our sole discretion,
        but we are particularly likely to do so if a user behaves
        inappropriately, harasses other users, makes discriminatory comments or
        posts Content not appropriate for a K-12 educational setting.
      </p>
      <p>
        The following are examples of the kind of Content you may not post on or
        through the Service. We reserve the right to investigate and take
        appropriate action against anyone who, in our sole discretion, violates
        this provision, including without limitation, removing the offending
        Content from the Services and terminating the accounts of such
        violators. Prohibited Content includes, but is not limited to, Content
        that, in the sole discretion of Legends of Learning:
      </p>
      <ul>
        <li>
          is patently offensive and promotes racism, bigotry, hatred or physical
          harm of any kind against any class or individual
        </li>
        <li>harasses or advocates harassment of another person</li>
        <li>exploits people in a sexual or violent manner</li>
        <li>
          contains sexually suggestive, excessively violent, or offensive
          subject matter
        </li>
        <li>solicits personal information from anyone under 18 years old</li>
        <li>
          includes information about another person that you have posted without
          that person&apos;s consent
        </li>
        <li>
          violates the privacy rights, publicity rights, copyrights, trademark
          rights, contract rights or any other rights of any person or risks any
          person&apos;s well-being
        </li>
        <li>
          contains or promotes information that you know is false or misleading,
          or promotes illegal activities or conduct that are abusive,
          threatening, obscene, defamatory or libelous
        </li>
        <li>
          contains or promotes an illegal or unauthorized copy of another
          person&apos;s copyrighted work
        </li>
        <li>
          solicits passwords or personally-identifying information for
          commercial or unlawful purposes from other users
        </li>
        <li>
          involves the transmission of junk mail, chain letters, unsolicited
          mass mailings or instant messages, or spam
        </li>
        <li>
          furthers or promotes any criminal activity or enterprise, or provides
          instructional information about illegal activities including, but not
          limited to, making or buying illegal weapons, violating someone&apos;s
          privacy, or providing or creating computer viruses
        </li>
        <li>
          involves commercial activities and/or sales without prior written
          consent from Legends of Learning, such as contests, sweepstakes,
          bartering, advertising, or pyramid schemes
        </li>
      </ul>
      <h2>Parents</h2>
      <p>
        By creating an account you agree to receive occasional emails on your
        child&apos;s progress on teacher assignments and within Awakening game,
        as well as on ways to improve learning.
      </p>
      <h2>Copyright Infringement</h2>
      <p>
        Legends of Learning asks others to respect its intellectual property
        rights, and we accordingly respect the intellectual property rights of
        others. If you believe that any Content on the Services violates your
        copyright, you are encouraged to notify Legends of Learning in
        accordance with the Legend of Learning Digital Millennium Copyright Act
        (&quot;DMCA&quot;) Policy, which is set forth below. Legends of Learning
        will respond to all such notices, including by removing the infringing
        content, as required or appropriate.
      </p>
      <h3>DMCA Policy</h3>
      <ul>
        <li>
          A physical or electronic signature of the copyright owner or a person
          authorized to act on their behalf.
        </li>
        <li>
          Identification of the copyrighted work claimed to have been infringed
          or if multiple copyrighted works at a single online site are covered
          by a single notification, a representative list of such works at that
          site.
        </li>
        <li>
          Identification of the material that is claimed to be infringing or to
          be the subject of infringing activity and that is to be removed or
          access to which is to be disabled, and information reasonably
          sufficient to permit the service provider to locate the material.
          Providing direct URLs to each set in the body of an email is the best
          way to help us locate content quickly.
        </li>
        <li>
          Contact information, such as your name, address, telephone number and,
          if available, email address
        </li>
        <li>
          A statement by you: (a) that you believe in good faith that the use of
          the content that you claim infringes a copyright is not authorized by
          law, or by the copyright owner or the owner&apos;s agent; and (b)
          under penalty of perjury, that all of the information contained in
          your infringement notice is accurate, and that you are either the
          copyright owner or a person authorized to act on their behalf.
        </li>
      </ul>
      <p>If sending by email: legal[@]legendsoflearning.com</p>
      <p>If sending by mail:</p>
      <address>
        DMCA Notice
        <br />
        Attention: Legal Department
        <br />
        Legends of Learning, Inc.
        <br />
        500 North Capitol Street, NW, Suite 230
        <br />
        Washington, D.C. 20001
      </address>
      <h2>Third Party Links</h2>
      <p>
        Our Services may contain links to third-party websites or resources.
        These are only for your convenience and therefore you access them at
        your own risk. We do not have any control over the availability or
        accuracy of these websites or resources nor do we endorse them or the
        content, products, or services available from them. Your use of these
        third-party websites or resources may be subject to their terms of use
        and privacy policies. Please review these documents before using those
        websites or resources or disclosing personally identifiable information.
      </p>
      <h2>Services Provided &quot;AS IS&quot;</h2>
      <p>
        You understand and agree that the Services are provided to you on an
        &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; basis. Legends of
        Learning does not warrant the accuracy, adequacy, or completeness of
        this information and materials and expressly disclaims liability for
        errors or omissions in them. We make no warranties or representations
        that: (i) information on the Services is accurate or complete; (ii) the
        functions contained in the Services will be uninterrupted or error-free
        (iii) that any messages you send through the Services will be delivered;
        or that (iv) your access or use of the Services will not result in any
        harm to your computer system, loss of data, or other harm.
      </p>
      <p>
        Without limiting the foregoing, to the maximum extent permitted under
        applicable law, WE DISCLAIM ALL WARRANTIES AND CONDITIONS, WHETHER
        EXPRESS OR IMPLIED, OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE, TITLE, OR NON-INFRINGEMENT AND WARRANTIES ARISING FROM COURSE
        OF DEALING OR COURSE OF PERFORMANCE.
      </p>
      <h2>Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless, Legends of Learning, our
        partners, affiliated companies, representatives, customer and licensors
        (including in each case their officers, directors employees and agents)
        (the &quot;Indemnified Parties&quot; and each an &quot;Indemnified
        Party&quot;) (from any losses, expenses, damages and costs (including
        reasonable attorneys&apos; fees) arising from any claims relating to
        your use of the Services, your breach of these Terms and Conditions, any
        information provided by you or any communication or transaction between
        you and another user of the Services. You agree to fully cooperate at
        your expense as reasonably required by an Indemnified Party. Each
        Indemnified Party may, at its election, assume the defense and control
        of any matter for which it is indemnified hereunder. You shall not
        settle any matter involving an Indemnified Party without the consent of
        the applicable Indemnified Party.
      </p>
      <h2>Limitation of Liability</h2>
      <p>
        YOU AGREE THAT LEGENDS OF LEARNING OR OUR OFFICERS, DIRECTORS,
        EMPLOYEES, AGENTS, PARTNERS, REPRESENTATIVES OR LICENSORS SHALL NOT BE
        LIABLE FOR ANY CLAIM (INCLUDING CLAIMS FOR BREACH OF CONTRACT,
        NEGLIGENCE OR TORT) RELATING DIRECTLY OR INDIRECTLY TO THESE TERMS AND
        CONDITIONS OR THE SERVICES. EVEN IF YOU HAVE NOTIFIED US ABOUT POTENTIAL
        DAMAGES, LOSSES OR EXPENSES, WE WILL NOT BE LIABLE FOR ANY DIRECT,
        INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES,
        INCLUDING LOST PROFITS, LOST SAVINGS, LOSS OF GOODWILL OR THE COST OF
        SUBSTITUTE GOODS.
      </p>
      <p>
        WE WILL NOT BE LIABLE IN ANY WAY FOR INTERRUPTION TO YOUR CLASSES, YOUR
        USE OF THE SERVICES OR INABILITY TO USE THE SERVICES OR CHANGES WE MAKE
        TO THE SERVICES OR OUR DECISION TO STOP PROVIDING THE SERVICES.
      </p>
      <p>
        IN THE EVENT OF ANY PROBLEM WITH THE SERVICES, YOU AGREE THAT YOUR SOLE
        AND EXCLUSIVE REMEDY IS TO CEASE USING THE SERVICES. The provisions of
        this Section apply up to the maximum extent permitted under applicable
        law. Some jurisdictions do not allow the limitation of liability in
        contracts, and as a result the contents of this Section may not apply to
        you. Nothing in this Section is intended to limit any rights you may
        have which may not be lawfully limited.
      </p>
      <h2>Legal Notices and Jurisdiction</h2>
      <p>
        If we need to contact you in connection with these Terms or your use of
        the Services, we will send any notices to the email address you last
        provided to us when you registered for use of the Services. We will also
        post general legal notices through the Services. You can send legal
        notices to us at legal@legendsoflearning.com.
      </p>
      <p>
        Any claims related to the Services or these Terms and Conditions brought
        by you or by us will be resolved under the laws of the state of Maryland
        (excluding choice of law principles) and must be brought in an
        appropriate court in that state. Both you and Legends of Learning agree
        to the jurisdiction of Maryland courts, and neither of us may object to
        having claims brought against us in Maryland on the grounds that it is
        not convenient.
      </p>
      <h2>Termination</h2>
      <p>
        We will cancel your account upon your written request, unless your
        account is provided through an agreement we have with have with another
        party, such as an Educational Institution. Please send all cancellation
        requests to support@legendsoflearning.com. After you have cancelled your
        account, you will not be able to access information generated under your
        account through the Platform. We may suspend or terminate your account
        at any time, in our sole discretion. This is especially likely if you
        violate these Terms and Conditions, fail to log in for an extended
        period of time or abuse the Services or other users. Only teachers or
        representatives of an Educational Institution may establish an account
        to use our Platform. If we become aware that a student has established
        an account, we will terminate the account.
      </p>
      <h2>Access from Overseas</h2>
      <p>
        We make no representation that the Services are appropriate or available
        for use in other locations, and access to them from territories where
        the Services are illegal is prohibited.
      </p>
      <h2>No Class Actions</h2>
      <p>
        You may only resolve disputes with Legends of Learning on an individual
        basis, and may not bring a claim as a plaintiff or a class member in a
        class, consolidated, or representative action. Class arbitrations, class
        actions, private attorney general actions, and consolidation with other
        arbitrations are not allowed.
      </p>
      <h2>General</h2>
      <p>
        If any provision of these Terms is held to be invalid, illegal, or
        unenforceable in any respect under any applicable law or rule in any
        jurisdiction, such invalidity, illegality, or unenforceability will not
        affect the effectiveness or validity of any provision in any other
        jurisdiction, and these Terms will be reformed, construed, and enforced
        in such jurisdiction as if such provision had never been contained
        herein. These Terms and our Privacy Policy and any additional agreements
        related to the Services constitute the entire agreement between you and
        us with respect to the Services, and they supersede all prior or
        contemporaneous communications and proposals, whether electronic, oral
        or written, between you and us with respect to the Services. We may
        provide notice to you under these Terms, in our discretion, by posting
        announcements to the Services and/or by sending emails to the email
        address you provided to us, if have provided one.
      </p>
      <h2>Questions</h2>
      <p>
        If you have questions regarding these Terms of Use, contact us at
        888-676-7771 or support[@]legendsoflearning.com.
      </p>
    </div>
  )
}

export default TermsOfServiceComponent
